module.exports = __webpack_public_path__ + "static/media/__present.7cfcc4ac.svg";